import { Message } from "@aviary";

interface Props {
  errors: string[];
}

const ValidationSummary = ({ errors, ...props }: Props) => {
  if (!errors || errors.length === 0) {
    return null;
  }

  const renderErrors = () => {
    if (errors.length === 1) {
      return <div>{errors[0]}</div>;
    }

    return errors.map(error => <li key={error}>{error}</li>);
  };

  return (
    <Message isColor="danger" {...props}>
      {renderErrors()}
    </Message>
  );
};

export { ValidationSummary };
